import { createFileRoute } from '@tanstack/react-router';
import { checkAnalyticsSecurityDomain } from '../../components/analytics/utils/routeGuards';
import AnalyticsPageLayout from '../../components/analytics/shared/AnalyticsPageLayout';
import { getCategoryById } from '../../components/analytics/config';
import SessionPerformanceDashboard from '../../components/analytics/session-performance/SessionPerformanceDashboard';
import { useAnalyticsFilters } from '../../components/analytics/filters';

export const Route = createFileRoute('/team-insights/sessions')({
  component: RouteComponent,
  beforeLoad: checkAnalyticsSecurityDomain({
    routeObject: 'analytics',
  }),
});

function RouteComponent() {
  const { filters, updateFilters } = useAnalyticsFilters();
  const category = getCategoryById('session-performance');

  if (!category) {
    return <div>Category not found</div>;
  }

  return (
    <AnalyticsPageLayout category={category} filters={filters} onFiltersChange={updateFilters}>
      <SessionPerformanceDashboard filters={filters} />
    </AnalyticsPageLayout>
  );
}
